import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import Mainambulance from "../DP_ambulance/Mainambulance";
import Hospital from "../DP_Health/Hospital";
import DPBlackspot from "../DP_Blackspot/DPBlackspot";
import DatapanelDeathdata from "../DP_DeathData/DatapanelDeathdata";
import ReportsRoadConditionData from "../RoadAccidentDashboard/Section1/ReportsRoadConditionData";
import ReportRoadAccidentData from "./ReportRoadAccidentData";

const TABS = [
  { id: "roadaccident", label: "Report Road Accident" },
  { id: "roadcondition", label: "Report Road Condition" },
  { id: "ambulance", label: "Ambulance" },
  { id: "hospital", label: "Hospital" },
  { id: "blackspot", label: "Black Spot" },
  { id: "deathdata", label: "Death Data" },
];

const ReportsRecords = () => {
  const [searchParams] = useSearchParams();
  const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
    ? searchParams.get("tab")
    : "ambulance";
  const [activeSection, setActiveSection] = useState(initialTab);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <div className="section-buttons-container" style={{ border: "0px" }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`section-button ${activeSection === tab.id ? "active" : ""}`}
            onClick={() => setActiveSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="section-content-container">
        <div className={`section-container ${activeSection === "ambulance" ? "active-section" : "hidden-section"}`}>
          <Mainambulance />
        </div>
        <div className={`section-container ${activeSection === "hospital" ? "active-section" : "hidden-section"}`}>
          <Hospital />
        </div>
        <div className={`section-container ${activeSection === "blackspot" ? "active-section" : "hidden-section"}`}>
          <DPBlackspot />
        </div>
        <div className={`section-container ${activeSection === "deathdata" ? "active-section" : "hidden-section"}`}>
          <DatapanelDeathdata />
        </div>
        <div className={`section-container ${activeSection === "roadcondition" ? "active-section" : "hidden-section"}`}>
          <ReportsRoadConditionData />
        </div>
        <div className={`section-container ${activeSection === "roadaccident" ? "active-section" : "hidden-section"}`}>
          <ReportRoadAccidentData />
        </div>
      </div>
    </div>
  );
};

export default ReportsRecords;
